import { useEffect } from 'react'
import { Button, Stack, Typography } from '@mui/material'
import { usePhoneVerificationModal } from '../../@biz_account/phone-verify/usePhoneVerificationModal'
import { useNavigate } from 'react-router-dom'
import { VerificationCodeInput } from '../../@biz_account/phone-verify/codeInput/VerificationCodeInput'
import { usePhoneStore } from './phoneStore'
import { Header } from '~/@ui/header/Header'

export const ChangePhoneCodePage = () => {
  const navigate = useNavigate()

  const { phone: storedPhone } = usePhoneStore()

  const isInvestorRoute = location.pathname.includes('/investor/')

  const {
    startVerification,

    verificationCode,
    verifyCodeInputState,

    handleCodeChange,
    handleSendAgainClick,

    waiting,
    secondsLeft,

    isStartLoading,
    isVerifyLoading,
  } = usePhoneVerificationModal({
    onSuccess: async () => {
      navigate(
        isInvestorRoute ? '/investor/user-profile' : '/vlastnik/user-profile'
      )
    },
  })

  const verifyCodeInputClassName = `i-verifycodeinput-${verifyCodeInputState}`

  const state = waiting || isStartLoading || isVerifyLoading

  useEffect(() => {
    if (!storedPhone) {
      navigate(
        isInvestorRoute
          ? '/investor/user-profile/change-phone'
          : '/vlastnik/user-profile/change-phone'
      )
    }

    startVerification(storedPhone)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Stack className="w-full h-dvh justify-between">
      <Stack>
        <Stack className="px-6 py-4">
          <Button
            className="w-16 h-11 bg-zGrey200"
            onClick={() =>
              navigate(
                isInvestorRoute
                  ? '/investor/user-profile/change-phone'
                  : '/vlastnik/user-profile/change-phone'
              )
            }>
            <Typography className="text-xl font-medium">{'<-'}</Typography>
          </Button>
        </Stack>

        <Stack className="w-full max-w-[768px] self-center gap-8 px-5">
          <Header
            title="Skontrolujte si telefón"
            text={`Na tel. číslo ${storedPhone} sme zaslali kód na overenie.`}
            className="pt-6"
          />

          <VerificationCodeInput
            value={verificationCode}
            onChange={handleCodeChange}
            stateClassName={verifyCodeInputClassName}
          />
        </Stack>

        <Stack className="items-center gap-8 mt-3">
          <Typography className="text-xs font-semibold text-zBlack200">
            {state ? `(Zostáva ${secondsLeft}s sekúnd)` : '(Neplatný kód)'}
          </Typography>
          <Stack className="">
            <Typography className="text-sm font-medium text-zGrey400">
              Neprišiel vám SMS kód?
            </Typography>
            <Button
              variant="text"
              onClick={handleSendAgainClick}
              disabled={state}
              className="min-h-[24px] underline">
              <Typography
                className="text-sm font-semibold"
                sx={(theme) => ({
                  color: state
                    ? theme.palette.custom.zGrey550
                    : theme.palette.custom.zBlack200,
                })}>
                Odoslať znova
              </Typography>
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}
